import { CheckCircleIcon } from "@phosphor-icons/react/dist/ssr/CheckCircle";
import { FileDashedIcon } from "@phosphor-icons/react/dist/ssr/FileDashed";
import { FileTextIcon } from "@phosphor-icons/react/dist/ssr/FileText";
import { FileXIcon } from "@phosphor-icons/react/dist/ssr/FileX";

import { ApplicationStatus } from "@up/data";
import { UPLink } from "@up/ui";

import { LineItem } from "../line-item";

import type { TApplicationStatus } from "@up/data";

export function AppStatus({
  isStudent = false,
  status,
}: {
  isStudent?: boolean;
  status?: TApplicationStatus;
}) {
  switch (status) {
    case ApplicationStatus.Denied:
      return (
        <LineItem compact={true} Icon={FileXIcon}>
          Application Status: Not Admitted
        </LineItem>
      );

    case ApplicationStatus.PendingReview:
      return (
        <LineItem compact={true} Icon={FileTextIcon}>
          Application Status: In Review
        </LineItem>
      );

    case ApplicationStatus.UserStarted:
      return (
        <LineItem
          as={isStudent ? UPLink : "div"}
          compact={true}
          href={isStudent ? "/application" : null}
          Icon={FileDashedIcon}
        >
          <div>
            Application Status: Incomplete
            {isStudent ? (
              <div>
                Please{" "}
                <span className="underline">complete your application</span>.
              </div>
            ) : null}
          </div>
        </LineItem>
      );

    case ApplicationStatus.Approved:
      return (
        <LineItem compact={true} Icon={CheckCircleIcon}>
          Application Status: Admitted
        </LineItem>
      );

    case ApplicationStatus.Abandoned:
    case undefined:
      return (
        <LineItem
          as={isStudent ? UPLink : "div"}
          compact={true}
          highlight={true}
          href={isStudent ? "/application" : null}
          Icon={FileDashedIcon}
        >
          <div>
            No application on file
            {isStudent ? (
              <div>
                Please <span className="underline">Apply Now</span>.
              </div>
            ) : null}
          </div>
        </LineItem>
      );

    default:
      return null;
  }
}
